import React, { useState } from "react";
import styles from "./styles.module.scss";
import LeftColoredTitle from "../../../../components/Titles/LeftColoredTitle";
import { InscrireBtn } from "../../../../components/buttons/Buttons";

import exemple from "../../../../assets/images/aluminies/al1.png";
import { Swippers } from "../../../../components/Carossel/Carossel";
import { HR1 } from "../../../../components/HRs/HRs";
import { useNavigate } from "react-router-dom";

function Alumini() {
  const [carossel, setcarossel] = useState(1);
  const navigate = useNavigate();
  const toInscription = () => {
    navigate("/inscription");
  };

  return (
    <div className={styles.main}>
      <LeftColoredTitle>UIK Alumni Network</LeftColoredTitle>

      <div className={styles.container2}>
        <p className={`${styles.desc}`}>
          L'Université Ibn Khaldoun compte aujourd'hui plus de 7000 diplômés
          issus de plus de trente nationalités différentes, qui ont poursuivi
          leur carrière dans divers domaines à travers le monde. L'association
          Alumni de l'UIK joue un rôle crucial en offrant un réseau
          professionnel visant à faciliter l'insertion et la mobilité
          professionnelle des anciens diplômés de l'université. UIK Alumni
          Network est une ressource essentielle pour les anciens étudiants de
          l'Université Ibn Khaldoun. Elle favorise le réseautage, le mentorat et
          l'accès à des opportunités professionnelles. Les anciens étudiants ont
          la possibilité de rester en contact avec leur alma mater grâce à cette
          association. De plus, elle propose des programmes de formation
          continue et des ateliers visant le développement professionnel. Par
          ailleurs, UIK Alumni Network offre un soutien précieux dans la
          recherche d'emploi et l'évolution de carrière grâce à son vaste réseau
          d'entreprises partenaires. Elle permet aux anciens étudiants de
          bénéficier du réseau et de l'expertise de professionnels chevronnés.
        </p>

        <InscrireBtn className={styles.btn} onClick={toInscription}>
          Rejoignez l’Association UIK <br /> Alumni
        </InscrireBtn>

        <HR1 />

        <LeftColoredTitle>Témoignages de nos alumni</LeftColoredTitle>

        <div className={styles.carossel}>
          <div className={styles.item}>
            <div className={styles.general}>
              <HexagoneImage img={exemple} />
              <h2>Meriem EL JED </h2>
              <h2>Licence en Finance, Class of 2013</h2>
            </div>
            <div className={styles.description}>
              <p className={`${styles.desc}`}>
                Je m'appelle Meriem El JED et j'ai étudié la finance à l'UIK.
                Après avoir obtenu mon diplôme, j'ai réalisé mon rêve d'être
                entrepreneuse en créant CHICH KHAN EVENTS, une entreprise
                d'événementiel. Bien que les débuts aient été difficiles, j'ai
                persévéré et travaillé dur pour faire de mon entreprise un des
                leaders sur le marché de l'événementiel. J'encourage donc tous
                les étudiants de l'UIK à poursuivre leurs rêves avec passion et
                détermination. N'ayez pas peur de prendre des risques et de
                travailler dur pour atteindre vos objectifs. L'UIK m'a fourni
                une excellente formation, qui a été essentielle pour mon succès
                en tant qu'entrepreneuse.
              </p>
            </div>
          </div>

          <Swippers />
        </div>
        <br />
        <br />
        <HR1 />
      </div>
    </div>
  );
}

const HexagoneImage = ({ img }) => {
  return (
    <div className={styles.hexagonal}>
      <div className={styles.sub_hexa}>
        <div className={styles.for_shadow}>
          <div
            className={styles.sub_sub_hexa}
            style={{ backgroundImage: `url(${img})` }}
          />
        </div>
      </div>
    </div>
  );
};

export default Alumini;
